export const MAIN_OFFICE_BRANCH_CODE = process.env.NODE_ENV === "development" ? "10098" : "99998";
